import React from 'react'
import PropTypes from 'prop-types'
import homeworksLogo from '../../../assets/logo.svg'

const stepLabels = ['Choose Service', 'Eligibility', 'Contact Info', 'Schedule']

const Navigation = ({ currentStepIndex, dataWasSent, setCurrentStepIndex, steps }) => {
  const isSuccess = dataWasSent || currentStepIndex >= steps.length - 1
  const activeStepNumber = isSuccess ? 5 : currentStepIndex + 1
  const totalPips = 4

  const pipClass = (i) => {
    if (i < activeStepNumber) return 'step-pip done'
    if (i === activeStepNumber) return 'step-pip active'
    return 'step-pip future'
  }

  const connectorClass = (i) =>
    `step-connector${i < activeStepNumber ? ' done' : ''}`

  const currentLabel = isSuccess ? 'Complete!' : stepLabels[currentStepIndex] || ''

  return (
    <header
      className="bg-white border-b border-stone-200 sticky top-0 z-50"
      style={{ boxShadow: '0 1px 8px rgba(0,0,0,0.06)' }}
    >
      <div className="max-w-3xl mx-auto px-4 h-16 flex items-center gap-4">

        {/* Logo */}
        <a
          href="https://www.homeworksenergy.com"
          className="flex items-center flex-shrink-0"
          style={{ textDecoration: 'none' }}
        >
          <img src={homeworksLogo} alt="HomeWorks Energy" style={{ height: 44, width: 'auto' }} />
        </a>

        {/* Desktop step pips */}
        <div className="hidden md:flex flex-1 items-center gap-0 ml-4">
          {[1, 2, 3, 4].map((i) => (
            <React.Fragment key={i}>
              <div className={pipClass(i)}>
                {i < activeStepNumber ? (
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path
                      d="M2 6l3 3 5-5"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                ) : (
                  i
                )}
              </div>
              {i < 4 && <div className={connectorClass(i)} />}
            </React.Fragment>
          ))}
        </div>

        {/* Desktop step label */}
        <div className="hidden md:block text-right ml-2 flex-shrink-0">
          <div style={{ fontSize: 12, fontWeight: 600, color: '#78716c' }}>{currentLabel}</div>
        </div>

        {/* Mobile step indicator */}
        <div className="md:hidden flex-1 text-right">
          <span className="text-sm font-semibold" style={{ color: '#78716c' }}>
            {isSuccess ? 'Complete!' : `Step ${currentStepIndex + 1} of ${totalPips}`}
          </span>
        </div>
      </div>

      {/* Mobile progress bar */}
      <div className="md:hidden h-1 bg-stone-100">
        <div
          className="mobile-progress-fill h-full rounded-r-full"
          style={{
            width: isSuccess ? '100%' : `${Math.round((currentStepIndex / totalPips) * 100)}%`,
            background: '#99c543',
          }}
        />
      </div>
    </header>
  )
}

Navigation.propTypes = {
  currentStepIndex: PropTypes.number.isRequired,
  dataWasSent: PropTypes.bool,
  setCurrentStepIndex: PropTypes.func.isRequired,
  steps: PropTypes.arrayOf(PropTypes.func).isRequired,
}

export default Navigation
